export const Colors = {
  pink: '#FFBDCF',
  pinkDark: '#B37283',
  pinkLight: '#FFD6E1',
  blueLight: '#A3E8FF',
  greenDark: '#60B36B'
}

export default Colors
